import { app } from '../../../../bootstrap/core';
import { authorizationState } from './authorization.state';
import { authorizationComponent } from './authorization.component';

app.config(authorizationState);
app.component(authorizationComponent.name, authorizationComponent);
